export const JET_PRESS_SITE_CREATE = "JetPressSiteCreate";
export const JET_PRESS_SITE_DELETE = "JetPressSiteDelete";
export const JET_PRESS_INSTANCE_CLONE = "JetPressInstanceClone";
export const JET_PRESS_INSTANCE_SYNC = "JetPressInstanceSync";
export const JET_PRESS_BACKUP_CREATE = "JetPressBackupCreate";
export const JET_PRESS_BACKUP_RESTORE = "JetPressBackupRestore";
export const JET_PRESS_BACKUP_DELETE = "JetPressBackupDelete";
export const JET_PRESS_PLUGIN_INSTALL = "JetPressPluginInstall";
export const JET_PRESS_PLUGIN_UNINSTALL = "JetPressPluginUninstall";
export const JET_PRESS_THEME_INSTALL = "JetPressThemeInstall";
export const JET_PRESS_THEME_UNINSTALL = "JetPressThemeUninstall";
